<template>
  <div class="category-select">
    <div v-for="category in categories" :key="category.id" class="checkbox">
      <input 
        type="checkbox" 
        :id="`${name}-${category.id}`" 
        :value="category.id" 
        v-model="selectedCategories" 
      />
      <label :for="`${name}-${category.id}`">{{ category.name }}</label>
    </div>
  </div>
</template>

<script>
export default {
  props: ['modelValue', 'categories','name'],
  data() {
    return {
      selectedCategories: [...this.modelValue]
    };
  },
  watch: {
    selectedCategories(newVal) {
      this.$emit('update:modelValue', newVal);
    },
    modelValue(){
      this.selectedCategories = this.modelValue;
    }
  }
};
</script>

<style scoped>
.category-select {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 33px;
  padding-top: 1px;
}
.checkbox {
  display: flex;
  align-items: center;
}
.checkbox input {
  display: none;
}

.checkbox input + label {
  position: relative;
  padding-left: 40px; /* Место для чекбокса */
  cursor: pointer;
  font-family: Satoshi;
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  color: rgb(85, 98, 114);
}

.checkbox input + label::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: 1px solid rgb(222, 230, 234);
  background-color: transparent;
}

.checkbox input:checked + label::before {
  background-color: rgb(255, 183, 16);;
  border-color: rgb(255, 183, 16);;
}

.checkbox input:checked + label::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 13px;
  height: 10px;
  background: url('data:image/svg+xml;utf8,<svg width="13.333313" height="10.000000" viewBox="0 0 13.3333 10" xmlns="http://www.w3.org/2000/svg"><path d="M4.99 7.64L12.22 0L13.33 1.17L4.99 10L0 4.7L1.11 3.52L4.99 7.64Z" fill="%23050505"/></svg>') no-repeat center center;
  background-size: contain;
}

.checkbox input:checked + label {
  color: rgb(5, 5, 5);
}
</style>
